import { SuppliersModel } from '@shared/@types/SuppliersModel';
import { createContext } from 'react';

export interface SupplierContextData {
    suppliers: SuppliersModel;
}

export const SupplierContext = createContext<SupplierContextData>(null);

export const business: string = 'business';
export const personal: string = 'personal';
